import Brand from "@/types/Brand.interface"

interface State {
    brand: Brand
}

const defaults = () => {
    return {
        brand: null
    }
}
export default {
    state: defaults(),
    mutations: {
        brandSet (state: State, brand: Brand): void {
            state.brand = brand
        },
        brandReset (state: State): void {
            Object.assign (state, defaults())
        }
    },
    actions: {
        brandDelete ({ commit, getters }, brandId: number): Promise<Brand> {
            //  Assemble the API endpoint
            const url = `${getters.api}/brand/${brandId}`

            //  Send the request
            return window.axios.delete(url).then(response => {
                //  Set our brand to null now that it is deleted
                commit('brandSet', null)

                //  Return the deleted brand
                return response.data
            }).catch(() => null)
        },
        brandGet ({ commit, getters }): Promise<Brand> {
            //  Assemble the API endpoint
            const url = `${getters.api}/brand`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our brand
                commit('brandSet', response.data)

                //  return our brand
                return response.data
            }).catch(() => null)
        },
        brandPost ({ commit, getters }, payload: Brand): Promise<Brand> {
            //  Assemble the API endpoint
            const url = `${getters.api}/brand`

            //  Send the request
            return window.axios.post(url, payload).then(response => {
                //  Set our brand
                commit('brandSet', response.data)

                //  Return our brand
                return response.data
            }).catch(() => null)
        },
        brandPut ({ commit, getters }, payload: Brand): Promise<Brand> {
            //  Assemble the API endpoint
            const url = `${getters.api}/brand`

            //  Send the request
            return window.axios.put(url, payload).then(response => {
                //  Set our brand
                commit('brandSet', response.data)

                //  Return our brand
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
       brand (state: State): Brand {
           return state.brand
       }
    }
}
